














import { Component, Vue, Watch } from "vue-property-decorator";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";
import EntityModal from "@/layouts/DashboardLayoutComponents/EntityModal.vue";

import shiftKindModel from "@/models/shiftKind.model";

@Component({
	components: { PaginatedSearch, CreationCard, FormField, EntityModal },
})
export default class ShiftKinds extends Vue {
	id: any = "";

	shiftKindModel: any;
	shiftKindCreationFields = [
		{ key: "name", class: "md-size-50" },
		{ key: "color", class: "md-size-50" },
	];
	shiftKindModalFields = [
		{ icon: "edit", name: "Dados", fields: [
			{ key: "name", class: "md-size-50" },
			{ key: "color", class: "md-size-50" },
		]},
		{ icon: "delete", name: "Excluir", fields: [
			{ key: "name", class: "md-size-50", props: { disabled: true } },
		]},
	];

	constructor() {
		super();
		this.shiftKindModel = shiftKindModel;
	}

	async mounted() {
		this.id = this.$route.params.id;
	}

	@Watch("$route")
	updateRoute(route: any) {
		this.id = route.params.id || "";
	}

	openShiftKind(shiftKind: any) {
		this.$router.push(`/administrativo/tipos-plantao/${shiftKind.id}`);
	}

	closeShiftKind() {
		this.$router.push('.');
		(this.$refs.shiftKindSearch as any).refresh();
	}
}
